module.exports = __webpack_public_path__ + "static/media/ArrowLeft.fe3a235d.svg";